export default {
  searchValue: '',
  filter: {
    color: [],
    category: [],
    opacity: [],
  },
  color: [
    { hex: 'FFFFFF', name: 'белый' },
    { hex: 'FFDEC5', name: 'персиковый' },
    { hex: 'FEEEDC', name: 'светло-желтый' },
    { hex: 'F9E4B9', name: 'бежевый' },
    { hex: 'AD6B32', name: 'бледный' },
    { hex: '975B48', name: 'охровый' },
    { hex: 'C28067', name: 'коричневый' },
    { hex: 'FF834D', name: 'оранжевый' },
    { hex: 'F55448', name: 'красный' },
    { hex: 'C7C4A2', name: 'сероватый' },
    { hex: 'FFBCDF', name: 'розовый' },
    { hex: 'AD4FBD', name: 'фиолетовый' },
    { hex: '95DAFF', name: 'голубой' },
    { hex: '5B70D2', name: 'синий' },
    { hex: '2CE1C6', name: 'морской' },
    { hex: '70CB71', name: 'зеленый' },
    { hex: 'BFC0BF', name: 'серый' },
    { hex: '323232', name: 'черный' },
    { hex: '985592', name: 'сиреневый' },
    { hex: '00cdcd', name: 'бирюзовый' },
    { hex: 'FFFF00', name: 'желтый' },
    { hex: 'FCDD76', name: 'песочный' },
    { hex: 'FDF4E3', name: 'кремовый' },
  ],
  category: [
    { text: 'e' },
    { text: '0' },
    { text: '1' },
    { text: '2' },
    { text: '3' },
    { text: '4' },
    { text: '5' },
  ],
};
